// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eMjY","type":"styles_type__2R8sp","choices":"styles_choices__1y_yP"};